import ExpensesCategoriesContainer from "./ExpensesCategoriesContainer";

export default ExpensesCategoriesContainer;
